import { Customer } from './customer.model';
import { EnumRoles, toEnumRole } from './enum-roles';
import { InvUser } from './inv-user.model';

/**
 * Sesión activa del usuario.
 * Los tokens de acceso y refresco son manejados por el BFF como cookies HttpOnly —
 * el frontend nunca los lee ni los almacena.
 */
export class AuthSession {
  constructor(
    public email: string = '',
    public customer: Customer | undefined = undefined,
    public invUser: InvUser | undefined = undefined,
    public isLoggedIn: boolean = false,
    public ownerId: number = 0,
    public role: EnumRoles = EnumRoles.DF_VIEWER,
  ) {}

  /** Nombre completo del usuario desde personal_data. */
  get fullName(): string {
    const pd = this.customer?.personal_data;
    if (!pd) return this.email;
    return `${pd.first_name} ${pd.last_name}`.trim();
  }

  /** Nombre de la empresa del owner. */
  get companyName(): string {
    return this.customer?.owner?.config?.company_name ?? '';
  }

  static fromJson(json: any): AuthSession {
    return new AuthSession(
      json.email,
      json.customer,
      json.invUser,
      json.isLoggedIn,
      json.ownerId,
      toEnumRole(json.role ?? EnumRoles.DF_VIEWER),
    );
  }

  toJson(): any {
    return {
      email:      this.email,
      customer:   this.customer,
      invUser:    this.invUser,
      isLoggedIn: this.isLoggedIn,
      ownerId:    this.ownerId,
      role:       this.role,
    };
  }
}
